import React from 'react';
import {Button, Spin, message, Modal} from 'antd';
import {Link, withRouter} from 'react-router-dom';
import Table from 'components/Table';
import abortAjaxHoc from 'components/abortAjaxHoc';
import ControlSeparator from 'components/ControlSeparator';
const {confirm} = Modal;

class OverseaCardSDKList extends React.Component {
    state = {loading:false, list:[], total:0};

    columns = [
        {title:'Scene ID', dataIndex:'scene_id', key:'scene_id', width:300},
        {title:'Scene Name', dataIndex:'name', key:'name'},
        {title:'Scene Description', dataIndex:'description', key:'description', render:value=>value || '-'},
        {
            title:'Operate',
            dataIndex:'state',
            key:'state',
            width:250,
            render:(state,row)=>{
                const isSys = state === 'default';
                return (
                    <ControlSeparator>
                        <a onClick={this.onCopy.bind(this,row.id)}>Copy and add</a>
                        <Link to={`/pages/card-scenes/edit/${row.id}`}>{isSys?'Check details':'Edit'}</Link>
                        {!isSys && <a onClick={this.onOperation.bind(this,row.id,'delete',row)}>Delete</a>}
                    </ControlSeparator>
                );
            }
        }
    ];

    load = params=>{
        const query = {page_size:params.limit, page:params.current};
        return this.props.abortableAjax('GET', '/overseas_ocr_card_scene', query).then(res=>{
            const data = res.data || {};
            this.setState({list:data.list || [], total:data.total || 0});
        });
    }

    onOperation = (id,type,item)=>{
        let params = {},confirmCont = '';
        if(type === 'setDefault'){
            params = {
                is_default:1
            };
            confirmCont = `Are you sure to set "${item.name}" as the default scene?`;
        }else if(type === 'delete'){
            params = {
                state:'deleted'
            };
            confirmCont = `Are you sure to delete "${item.name}"?`;
        }
        confirm({
            title:confirmCont,
            onOk:()=>{
                this.setState({loading:true});
                return this.props.abortableAjax('POST','/overseas_ocr_card_scene/'+id,params).then(()=>{
                    message.success('Successful operation');
                    this.table.refresh();
                }).finally(()=>{
                    this.setState({loading:false});
                });
            }
        });
    }

    onCopy = id=>{
        this.setState({loading:true});
        this.props.abortableAjax('POST', '/copy_overseas_ocr_card_scene', {
            overseas_ocr_card_scene_id:id
        }).then(res=>{
            this.props.history.push(`/pages/card-scenes/edit/${res.data.id}`);
        }).catch(()=>this.setState({loading:false}));
    }

    render(){
        return <Spin spinning={this.state.loading}>
            <Link to="/pages/card-scenes/create">
                <Button type="primary" style={{margin:'10px 0'}} >New Card SDK Scene</Button>
            </Link>
            <Table autoLoad ref={ref=>{this.table=ref;}} rowKey="id"
                dataSource={this.state.list} columns={this.columns} onSubmit={this.load} total={this.state.total}/>
        </Spin>;
    }
}

export default abortAjaxHoc(withRouter(OverseaCardSDKList));



// WEBPACK FOOTER //
// ./src/pages/OverseaCard/OverseaCardSDKList.js